// extracted by mini-css-extract-plugin
export default {"mobile":"_42Plx","root":"JZp7+","onImage":"NXBOJ"};